export default __webpack_public_path__ + "static/media/Resume.0d265073.pdf";